<template>
  <button class="icon-button" :class="buttonClasses" v-on="$listeners">
    <span class="icon icon-button__icon" :class="iconClasses">{{ iconChar }}</span>
  </button>
</template>

<script>
import { ICON_VALUE } from '@/constants/icons';

export default {
  name: 'IconButton',
  props: {
    iconName: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    darkTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconChar() {
      return ICON_VALUE[this.iconName];
    },
    iconClasses() {
      return {
        'icon-button__icon--large': this.large
      };
    },
    buttonClasses() {
      return {
        'icon-button--transparent': this.transparent,
        'icon-button--text': this.text,
        'icon-button--small': this.small,
        'icon-button--dark-theme': this.darkTheme
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/icon.scss';

.icon-button {
  display: flex;
  width: 84px;
  height: 84px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid $merino-color;
  color: $dove-gray-color;
  font-size: 36px;
  outline: none;
  cursor: pointer;
  background-color: $merino-color;

  &:hover {
    background-color: $merino-color;
    border-color: $westar-color;
    color: $dove-gray-color;
  }

  &--dark-theme {
    background-color: $gun-powder-color;
    color: $white-color;
    border-color: transparent;

    &:hover {
      background-color: $gun-powder-color;
      color: $white-color;
      border-color: $white-color;
    }
  }

  &--transparent {
    background-color: transparent;
    border-color: transparent;
  }

  &--small {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  &--text {
    background-color: transparent;
    border-color: transparent;

    &:hover {
      background-color: transparent;
      border-color: transparent;
    }
  }

  &__icon {
    &--large {
      font-size: 52px;
    }
  }
}

@media (min-width: 960px) {
  .icon-button {
    color: $silver-color;

    &--dark-theme {
      color: $concord-color;
    }
  }
}
</style>
